export class ModelPin {
  constructor({ pinName }) {
    this.pinName = pinName;
    this.stimulus = ""; // stimulus name
    this.voltage = "";
    this.type = ""; // CLK|SDR|DDR|GND|VCC|VEC(stimulus) - Driver nd_in/nd_en pin
  }
}